import { render } from "./OutgoingCallElement.vue?vue&type=template&id=3825c1fc"
import script from "./OutgoingCallElement.vue?vue&type=script&lang=js"
export * from "./OutgoingCallElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__